import { AccessToken } from "../../../store/token/TokenSlice";

export type StorageUtil = {
  discardAccessToken: () => void;
  getAccessToken: () => string;
  hasAccessToken: () => void;
  saveAccessToken: (token: AccessToken) => void;
  saveRefreshToken: (refreshToken: string) => void;
  getRefreshToken: () => string | null;
};

export const configureStorage = () => {
  let storedAccessToken: AccessToken;
  let storedRefreshToken: string | null = null;
  let storedExpiresAt: number | null = null;

  return {
    discardAccessToken: () => {
      storedAccessToken = null;
      storedRefreshToken = null;
      storedExpiresAt = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("expires_at");
    },
    getAccessToken: () => {
      // Verificar se o token expirou
      if (storedExpiresAt && Date.now() >= storedExpiresAt) {
        storedAccessToken = null;
        storedRefreshToken = null;
        storedExpiresAt = null;
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("expires_at");
        return null;
      }

      return storedAccessToken;
    },
    hasAccessToken: () => {
      if (!storedAccessToken || !storedExpiresAt) return false;
      return Date.now() < storedExpiresAt;
    },
    saveAccessToken: (token: AccessToken) => {
      storedAccessToken = token;
      if (token) {
        localStorage.setItem("access_token", token);
        // Definir expiração para 1 hora (ajustar conforme necessário)
        storedExpiresAt = Date.now() + 60 * 60 * 1000;
        localStorage.setItem("expires_at", storedExpiresAt.toString());
      }
    },
    saveRefreshToken: (refreshToken: string) => {
      storedRefreshToken = refreshToken;
      localStorage.setItem("refresh_token", refreshToken);
    },
    getRefreshToken: () => {
      return storedRefreshToken;
    },
  } as StorageUtil;
};

export const extractAccessTokenFromWindowLocation = (window?: Window) => {
  if (!window || !window.location || !window.location.href || typeof window.location.href !== "string") {
    return;
  }

  let token: string | undefined;

  const replacer = (substring: string, arg: string): string => {
    token = arg;
    return substring;
  };

  window.location.href.replace(/access_token=([^&]+)/u, replacer);

  return token;
};

export const configureAccessToken = (window: Window | undefined, storage: StorageUtil) => {
  const urlToken = extractAccessTokenFromWindowLocation(window);

  if (urlToken) {
    storage.saveAccessToken(urlToken);
  }

  return storage;
};

export const accessToken = configureAccessToken(window, configureStorage());
